import { useSelector } from 'react-redux';
import PieChartRepresentation from '../../components/shared/charts/PieChart';

const ComplaintCategories = ({ complaintCategoriesData }) => {
    const { serviceRequestCategories } = useSelector((state) => state.categories || {
        serviceRequestCategories: [],
    });

    const { datapoints, title } = complaintCategoriesData;

    const mappedData = datapoints.map((point) => {
        const matchedCategory = serviceRequestCategories.find(cat => cat.value === point.value);
        return {
            value: matchedCategory?.label || point.value,  // label for chart
            count: point.count                             // numeric count
        };
    });

    return (
        <PieChartRepresentation
            title={title}
            subTitle="Distribution of complaints by complaint category"
            data={mappedData}
            outerRadius="60%"
        />
    );
};

export default ComplaintCategories;
